import React from 'react';
import PropTypes from 'prop-types';

import Loading from 'components/App/Loading';
import Map from 'components/App/Map';

import styles from './CoordinateMap.module.scss';

function CoordinateMap({
  defaultPosition,
  validation,
  mapRef,
}) {
  const newDefaultPosition = {
    lat: parseFloat(defaultPosition?.split(',')[0]),
    lng: parseFloat(defaultPosition?.split(',')[1]),
  };

  const handleMapClick = (e) => {
    validation.setFieldValue('coordinates', `${e.latLng.lat()},${e.latLng.lng()}`);
    mapRef.current?.panTo({ lat: e.latLng.lat(), lng: e.latLng.lng() });
  };

  const handlePlaceSelected = ({ lat, lng }) => {
    validation.setFieldValue('coordinates', `${lat},${lng}`);
  };

  const mapKey = process.env.REACT_APP_ENV_GOOGLE_KEY;

  return (
    <div className={styles.Container}>
      <Map
        newDefaultPosition={newDefaultPosition}
        handleMapClick={handleMapClick}
        onPlaceSelected={handlePlaceSelected}
        mapRef={mapRef}
        googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${mapKey}&libraries=places`}
        loadingElement={<Loading />}
        containerElement={<div className="MapContainer" />}
        mapElement={<div className="MapElement" />}
      />
    </div>
  );
}

export default CoordinateMap;

CoordinateMap.propTypes = {
  defaultPosition: PropTypes.string.isRequired,
  validation: PropTypes.instanceOf(Object).isRequired,
  mapRef: PropTypes.instanceOf(Object).isRequired,
};
